// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"8db491e6","119":"08742410","194":"eea127a2","297":"ef4f01c0","356":"8abc98c8","379":"0128bad7","449":"788bce25","453":"24c5476b","458":"0288808e","481":"a1d39d8c","582":"1cc4de9d","676":"d4fd3191","718":"377e9b96"}[chunkId] + ".chunk.js";
};